// extracted by mini-css-extract-plugin
export const noFavoritesCard = "favorites-workouts-module--no-favorites-card--3U6R6";
export const placeHolder = "favorites-workouts-module--place-holder--2_FZo";
export const favIcon = "favorites-workouts-module--fav-icon--128Jk";
export const noFavoritesHeader = "favorites-workouts-module--no-favorites-header--1SFMX";
export const noFavoritesTop = "favorites-workouts-module--no-favorites-top--2wmjx";
export const wrapper = "favorites-workouts-module--wrapper--11uwe";